// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".3e5c2554b7e7a7bfd922c8ac68d0a525e6a3fb91.chunk.js";
};